import React from 'react';
import styled from 'styled-components';
import { standardDateTime } from '@ibinder/common-utils';
import { ExpandableCard } from '@ibinder/common-frontend';

const Container = styled.div`
  animation: identifier 350ms;
  margin-bottom: 1rem;
  @keyframes identifier {
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 80px;
    }
  }
`;

interface Props {
  userBlock: USER_BLOCK;
  loading: boolean;
}

interface USER_BLOCK {
  get: {
    active: boolean;
    createdDate: string | null;
    description: string | null;
  };
}

const EmailBlockData = ({ userBlock, loading }: Props) => {
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Container>
      {userBlock && (
        <ExpandableCard
          expanded={false}
          headerInfo={`Blocked: ${userBlock?.get?.active ? 'Yes' : 'No'}`}
        >
          <ul>
            <li>
              {`description: ${
                userBlock?.get?.description ?? 'No description set'
              }`}
            </li>
            <li>
              {`date: ${
                userBlock?.get?.createdDate
                  ? standardDateTime(userBlock?.get?.createdDate)
                  : 'No date set'
              }`}
            </li>
          </ul>
        </ExpandableCard>
      )}
    </Container>
  );
};

export default EmailBlockData;
